const styles = () => ({
  root: {
    width: '100%',
  },
})

export default styles
